export default {
	tenantId: "boc_uat",
	appId: "coverStudio",

	fileSystem: {
		bucketName: "boc--uat"
	}
}
